<template>
    <section id="picture_content">

        <div class="container">

            <h3 class="pt-4 text-center">الصور</h3>

            <p class="text-center mt-3">مجموعة من الصور المتنوعة التي توضح المسابقات المختلفة والمتنوعة التي تمت المشاركة
                فيها او تنظيمها من قبل الشركة.</p>

            <div id="carouselPictureComponents" class="carousel slide carousel-fade mt-4 mt-lg-3" data-bs-ride="carousel">

                <div class="carousel-inner">

                    <!-- data-bs-interval="10000" -->
                    <div class="carousel-item active">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_1.webp" alt="">
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_2.webp" alt="">
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_3.webp" alt="">
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_4.webp" alt="">
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_5.webp" alt="">
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_6.webp" alt="">
                        </div>
                    </div>

                    <div class="carousel-item">
                        <div class="img_wrapper">
                            <img src="@/assets/images/pictures/pic_7.webp" alt="">
                        </div>
                    </div>

                </div>

                <!-- https://www.youtube.com/watch?v=BrCz-FlPGgk -->

                <!-- Carousel controls -->

                <div class="d-flex justify-content-center">

                    <button class="carousel-control-next" type="button" data-bs-target="#carouselPictureComponents"
                        data-bs-slide="next">
                        <font-awesome-icon :icon="['fas', 'fa-arrow-right']" />
                    </button>

                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselPictureComponents"
                        data-bs-slide="prev">
                        <font-awesome-icon :icon="['fas', 'fa-arrow-left']" />
                    </button>

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'Picture',
}
</script>

<style lang="scss" scoped>
#picture_content {

    min-height: 100vh;
    
    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
        min-height: 100vh;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        p {
            color: $White;
            font-size: 16px;
            line-height: 180%;
            margin-bottom: 0;
        }

        .carousel {

            width: 758px;

            @include breakpoints(x-small) {
                width: 343px;
            }

            @include breakpoints(small) {
                width: 500px;
            }

            @include breakpoints(medium) {
                width: 500px;
            }

            margin: 0 auto;

            .carousel-inner {

                .carousel-item {

                    position: relative;

                    width: 758px;
                    height: 635px;

                    @include breakpoints(x-small) {
                        width: 343px;
                        height: 287px;
                    }

                    @include breakpoints(small) {
                        width: 500px;
                        height: 419px;
                    }

                    @include breakpoints(medium) {
                        width: 500px;
                        height: 419px;
                    }

                    background: $Green;
                    box-sizing: border-box;

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);


                    .img_wrapper {

                        position: absolute;
                        top: 1px;
                        left: 1px;

                        width: 756px;
                        height: 633px;

                        @include breakpoints(x-small) {
                            width: 341px;
                            height: 285px;
                        }

                        @include breakpoints(small) {
                            width: 498px;
                            height: 417px;
                        }

                        @include breakpoints(medium) {
                            width: 498px;
                            height: 417px;
                        }

                        // https://www.cssportal.com/css-clip-path-generator/
                        // CSS Vendor Prefixes
                        -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                        -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                        -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                        -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                        clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);


                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            opacity: 0.9;
                        }

                        img:hover {
                            opacity: 1;
                            -webkit-transition: opacity 0.5s linear 0.2s;
                            -moz-transition: opacity 0.5s linear 0.2s;
                            transition: opacity 0.5s linear 0.2s;
                        }
                    }
                }

            }

            .carousel-control-prev,
            .carousel-control-next {
                position: static;
                padding-top: 15px;
                width: 70px;

            }

            .carousel-control-prev svg,
            .carousel-control-next svg {
                color: $Green;
                font-size: 24px;
            }


        }

    }

}
</style>